export default __webpack_public_path__ + "static/shopify-8f1e96c3292dc8818bbe7f3f6094da0e.png";